import Vue from 'vue';
import { BootstrapVueIcons } from 'bootstrap-vue';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css';

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
